import { render } from "./GPACard.vue?vue&type=template&id=0d02aa45"
import script from "./GPACard.vue?vue&type=script&lang=js"
export * from "./GPACard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__